import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { CampaignState } from 'modules/domains/campaign';
import {
  CHOOSE_CAMPAIGN_COLUMNS,
  CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM,
  CHOOSE_CAMPAIGN_TABLE_COLUMN,
} from 'modules/experiments/types';
import { ExperimentState } from 'modules/graphql';

export const chooseCampaignColumns: CHOOSE_CAMPAIGN_TABLE_COLUMN[] = [
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.id,
    label: 'ID',
    isSortable: false,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: true,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.CAMPAIGN_NAME,
    label: 'Campaign name',
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: true,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.STATUS,
    label: 'Status',
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.CAMPAIGN_TYPE,
    label: 'Campaign type',
    isSortable: false,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.MEDIUM,
    label: 'Medium',
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.EXPERIMENT_NAME,
    label: 'Experiment name',
    isSortable: false,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: false,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.LAST_MODIFIED,
    label: 'Last modified',
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.DESCENDING,
    isRightAligned: false,
  },
  {
    id: CHOOSE_CAMPAIGN_COLUMNS.ACTION_MENU,
    label: ` `,
    isSortable: false,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
    isRightAligned: true,
  },
];

export const CHOOSE_CAMPAIGN_SORT_ENUM_LOOKUP = {
  [CHOOSE_CAMPAIGN_COLUMNS.CAMPAIGN_NAME]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.CAMPAIGN_NAME,
  [CHOOSE_CAMPAIGN_COLUMNS.STATUS]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.STATUS,
  [CHOOSE_CAMPAIGN_COLUMNS.MEDIUM]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.MEDIUM,
  [CHOOSE_CAMPAIGN_COLUMNS.LAST_MODIFIED]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.LAST_MODIFIED,
  // Additional columns that are not sortable to make typescript happy
  [CHOOSE_CAMPAIGN_COLUMNS.id]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.CAMPAIGN_NAME,
  [CHOOSE_CAMPAIGN_COLUMNS.EXPERIMENT_NAME]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.CAMPAIGN_NAME,
  [CHOOSE_CAMPAIGN_COLUMNS.CAMPAIGN_TYPE]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.CAMPAIGN_NAME,
  [CHOOSE_CAMPAIGN_COLUMNS.ACTION_MENU]: CHOOSE_CAMPAIGN_COLUMN_SORT_ENUM.CAMPAIGN_NAME,
};

export const VALID_BLAST_CAMPAIGN_STATES = [
  CampaignState.Draft,
  CampaignState.Ready,
  CampaignState.Scheduled,
  CampaignState.Recurring,
];

// Recurring, scheduled doesn't exist for trigger
export const VALID_TRIGGERED_CAMPAIGN_STATES = [
  CampaignState.Draft,
  CampaignState.Ready,
  CampaignState.Scheduled, // not possible
  CampaignState.Recurring, // not possible
  CampaignState.Running,
];

export const INVALID_BASE_CAMPAIGN_STATES = [
  CampaignState.Archived,
  CampaignState.Aborted,
  CampaignState.Finished,
];

export const VALID_EXPERIMENT_STATES = [
  ExperimentState.FINISHED,
  ExperimentState.ERRORED,
  ExperimentState.CANCELLED,
];
export const INVALID_DRAFT_EXPERIMENT_STATES = [ExperimentState.DRAFT, ExperimentState.READY];
export const INVALID_RUNNING_EXPERIMENT_STATES = [
  ExperimentState.RUNNING,
  ExperimentState.SENDING_TO_REMAINDER,
  ExperimentState.USER_SELECTED_WINNER,
  ExperimentState.WINNER_FOUND,
];
